<template>
  <div class="link-views white-bg">
    <div class="top">
      <span style="display:none;">{{isCollegeId}}</span>
      <span class="theme">{{this.$route.params.collegeName}}文章管理</span>
      <router-link :to="{name:'college'}">
        <Button type="primary" class="ml">返回</Button>
      </router-link>
    </div>
    <div class="top">
      <Button type="primary" @click="addItemFn">添加</Button>
    </div>
    <div class="select-div">
      <div class="mr">
        <span>选择栏目：</span>
        <i-select v-model="pageData.ColumnId" style="width:200px">
          <i-option
            v-for="item in ColumnList"
            :value="item.CollegeColumnId"
            :key="item.CollegeColumnId"
          >{{ item.ColumnName }}</i-option>
        </i-select>
      </div>
      <div v-for="(item,index) in ColumnList" :key="index">
        <div
          class="mr"
          v-if="pageData.ColumnId==item.CollegeColumnId"
          style="display:inline-block;"
        >
          <span>选择子栏目：</span>
          <i-select v-model="pageData.SubColumnId" style="width:200px">
            <i-option
              v-for="obj in item.Result"
              :value="obj.SubColumnId"
              :key="obj.SubColumnId"
            >{{ obj.SubColumnName }}</i-option>
          </i-select>
        </div>
      </div>
      <div>
        <Button
          type="primary"
          class="mr"
          icon="md-search"
          @click="sureSearch(pageData.ColumnId,pageData.SubColumnId)"
        >查询</Button>
        <Button type="primary" icon="md-refresh" @click="sureSearch(0,0)">重置</Button>
      </div>
    </div>
    <div class="table-div">
      <!-- 表格 -->
      <Table :columns="columns" :data="listObj.Result" :loading="loading">
        <template slot-scope="{ index }" slot="Index">
          <div>{{(listObj.page-1)*(pageData.size)+(index+1)}}</div>
        </template>
        <template slot-scope="{ row }" slot="ColumnName">
          <div>{{row.ColumnName}}——{{row.SubColumnName}}</div>
        </template>
        <template slot-scope="{ row }" slot="action">
          <div class="action-table">
            <a @click="editItemFn(row)">编辑</a>
            <a @click="delItemFn(row)">删除</a>
          </div>
        </template>
      </Table>
      <!-- 分页 -->
      <div class="page-div">
        <Page
          :total="listObj.records"
          :current="pageData.page"
          :page-size="pageData.size"
          @on-change="changePage"
        />
      </div>
    </div>
    <!-- 模态框 -->
    <Modal
      v-model="showfullscreen"
      fullscreen
      title="编辑文章"
      :class="{'myfullscreen':true,'noLeft':isCollapsed }"
      :mask-closable="false"
    >
      <Form ref="editItem" :model="editItem" :label-width="110" :rules="ruleValidate">
        <FormItem label="所属栏目" prop="ColumnId" style="position:relative;z-index:20000;">
          <i-select v-model="editItem.ColumnId" style="width:200px">
            <i-option
              v-for="item in ColumnList"
              :value="item.CollegeColumnId"
              :key="item.CollegeColumnId"
            >{{ item.ColumnName }}</i-option>
          </i-select>
        </FormItem>
        <div v-for="(item,index) in ColumnList" :key="index">
          <div v-if="editItem.ColumnId==item.CollegeColumnId">
            <FormItem label="选择子栏目：" prop="ColumnId" style="position:relative;z-index:19999;">
              <i-select v-model="editItem.SubColumnId" style="width:200px">
                <i-option
                  v-for="obj in item.Result"
                  :value="obj.SubColumnId"
                  :key="obj.SubColumnId"
                >{{ obj.SubColumnName }}</i-option>
              </i-select>
            </FormItem>
          </div>
        </div>
        <FormItem label="文章标题" prop="Title">
          <Input clearable v-model="editItem.Title"/>
        </FormItem>
        <FormItem label="文章内容" prop="Content">
          <Input clearable v-model="editItem.Content" style="display:none"/>
          <editorElem :catchData="catchData" :content="editItem.Content"></editorElem>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="showfullscreen=false">取消</Button>
        <Button type="primary" @click="sureEdit('editItem')">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import * as homeConst from "../../../apiconfig/index.js";
import * as homeApi from "../../../api/home-api.js";
import editorElem from "../../../components/Editor";
export default {
  name: "essayCollege",
  data() {
    return {
      port: homeConst.baseUrl + "/", //baseurl
      pageData: {
        ColumnId: 0,
        SubColumnId: 0,
        page: 1,
        size: 10
      }, //分页条数
      loading: false,
      listObj: { Result: [] }, //根据分页条数获取数据详情
      columns: [
        //设置表格参数
        {
          title: "编号",
          slot: "Index",
          width: 80,
          align: "center"
        },
        {
          title: "文章标题",
          key: "Title",
          className: "center"
        },
        {
          title: "所属栏目",
          slot: "ColumnName",
          align: "center"
        },
        {
          title: "发布时间",
          key: "CreateTime",
          align: "center"
        },
        {
          title: "可选操作",
          slot: "action",
          align: "center"
        }
      ], //文章表格配置
      showfullscreen: false,
      ColumnList: [], //栏目列表
      editItem: {},
      ruleValidate: {
        ColumnId: [
          {
            required: true,
            type: "number",
            message: "请选择所属栏目",
            trigger: "change"
          }
        ],
        Title: [
          { required: true, message: "文章标题不能为空", trigger: "blur" }
        ],
        Content: [
          { required: true, message: "文章内容不能为空", trigger: "blur" }
        ]
      }, //表单验证
      editApi: "",
      CollegeId: 0
    };
  },
  components: {
    editorElem
  },
  computed: {
    isCollapsed() {
      return this.$store.state.isCollapsed;
    },
    isCollegeId() {
      this.CollegeId = this.$route.params.id;
      return this.$route.params.id;
    }
  },
  watch: {},
  mounted() {
    this.CollegeId = this.$route.params.id;

    this.GetSchoolColumnList(this.CollegeId); //获取栏目列表
    this.getDataList();
  },
  methods: {
    // 获取栏目列表
    async GetSchoolColumnList(CollegeId) {
      this.ColumnList = await homeApi.GetCollegeColumnList({
        CollegeId: CollegeId
      });
    },
    // 获取轮播图列表
    async getDataList() {
      this.listObj = await homeApi.GetCollegeArticleList({
        CollegeId: this.CollegeId,
        ColumnId: this.pageData.ColumnId ? this.pageData.ColumnId : 0,
        SubColumnId: this.pageData.SubColumnId ? this.pageData.SubColumnId : 0,
        page: this.pageData.page ? this.pageData.page : 1,
        size: this.pageData.size ? this.pageData.size : 10
      });
      this.loading = false;
    },
    // 按条件搜索
    sureSearch(ColumnId, SubColumnId) {
      this.pageData.ColumnId = ColumnId;
      this.pageData.SubColumnId = SubColumnId;
      this.pageData.page = 1;
      this.getDataList();
    },
    // 分页
    changePage(page) {
      this.pageData.page = page;
      this.getDataList();
    },

    // 添加文章
    addItemFn() {
      this.$refs["editItem"].resetFields();
      this.editItem.Content = "";
      this.editItem = {};
      this.editApi = "AddCollegeArticle";
      this.showfullscreen = true;
    },
    //编辑文章
    editItemFn(row) {
      this.editItem = JSON.parse(JSON.stringify(row));
      this.editApi = "AmendCollegeArticle";
      this.showfullscreen = true;
    },
    // 确认添加编辑文章
    sureEdit(name) {
      this.editItem.CollegeId = this.CollegeId;
      this.$refs[name].validate(valid => {
        if (valid) {
          homeApi[this.editApi](this.editItem).then(res => {
            if (res.success) {
              this.pageData.ColumnId = 0;
              this.pageData.SubColumnId = 0;
              this.pageData.page = 1;
              this.getDataList();
              this.showfullscreen = false;
              this.$Message.success({
                content: res.msg,
                duration: 3
              });
            } else {
              this.$Message.error({
                content: res.msg,
                duration: 3
              });
            }
          });
        } else {
          this.$Message.error({
            content: "数据不符合要求",
            duration: 3
          });
        }
      });
    },
    //删除文章
    delItemFn(row) {
      this.$Modal.confirm({
        title: "删除文章",
        content: "确认删除" + row.Title,
        onOk: () => {
          homeApi.DelCollegeArticle({ ArticleId: row.ArticleId }).then(res => {
            if (res.success) {
              this.pageData.ColumnId = 0;
              this.pageData.SubColumnId = 0;
              this.pageData.page = 1;
              this.getDataList();
              this.showfullscreen = false;
              this.$Message.success({
                content: res.msg,
                duration: 3
              });
            } else {
              this.$Message.error({
                content: res.msg,
                duration: 3
              });
            }
          });
        }
      });
    },
    catchData(val) {
      this.editItem.Content = val;
    }
  }
};
</script>

<style scoped>
</style>